import { createFileRoute } from "@tanstack/react-router";
import { DevicesXtelPage } from "@charphq/ui/components/device/devices-xtel-page";

export const Route = createFileRoute("/devices/xtel")({
  component: XtelDevicesComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    page: Number(search.page) || 1,
    pageSize: Number(search.pageSize) || 50,
    sortBy: (search.sortBy as string) || undefined,
    sortDirection: (search.sortDirection as "asc" | "desc") || undefined,
    globalFilter: (search.globalFilter as string) || undefined,
    columnFilters: (search.columnFilters as Record<string, unknown>) || undefined,
  }),
});

function XtelDevicesComponent() {
  const search = Route.useSearch();

  return <DevicesXtelPage searchParams={search} />;
}
